import { getUserTypes } from "../actions/usuariosActions";
import {
    LOGIN,
    LOGOUT,
    SET_AUTHENTICATED,
    EDITANDO,
    SET_OBJECT,
    RESET_OBJECT,
    LIMPIAR_FILTRO,
    FETCH_LOCALIDADES,
    SET_USER_CREDENTIALS,
    SET_MFA_STATUS,
    SET_CHAT_CONNECTION_ID,
} from '../actions/types';

const initialState = {
    nombre: "",
    userId: 0,
    codProv: null,
    isAuthenticated: false,
    idSeller: null,
    userName: "",
    tipoUsuario: 0,
    userType: getUserTypes(0),
    limpiar: {
        publicaciones: true,
        ordenes: true,
        sellers: true,
        dashboard: true,
        rebates: true,
        liquidaciones: true,
        grupoPlanes: true
    },
    editando: false,
    resetObject: false,
    generalObject: {},
    localidades: [],
    userCredentials: {
        user: '',
        password: ''
    },
    mfaStatus: {
        mfaHabilitado: false,
        mfaConfirmado: false,
        codigoDobleAutenticacion: '',
    },
    chatConnectionId: null
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_OBJECT:
            return {
                ...state,
                generalObject: action.payload,
            };

        case RESET_OBJECT:
            return {
                ...state,
                resetObject: action.payload,
            };

        case EDITANDO:
            return {
                ...state,
                editando: action.payload,
            };

        case LIMPIAR_FILTRO:
            return {
                ...state,
                limpiar: action.payload,
            };

        case SET_AUTHENTICATED:
            return {
                ...state,
                isAuthenticated: action.payload,
            };

        case LOGOUT:
            return {
                ...state,
                idSeller: null,
                isAuthenticated: false,
                userName: "",
                tipoUsuario: 0,
                userType: getUserTypes(0)
            };

        case LOGIN: {
            const updatedUserTypes = getUserTypes(action.payload.tipoUsuario);
            return {
                ...state,
                isAuthenticated: true,
                idSeller: action.payload.idSeller,
                userName: action.payload.userName,
                tipoUsuario: action.payload.tipoUsuario,
                userId: action.payload.userId,
                codProv: action.payload.codProv,
                userType: updatedUserTypes
            }
        };

        case FETCH_LOCALIDADES:
            return {
                ...state,
                localidades: action.payload
            };

        case SET_USER_CREDENTIALS:
            return {
                ...state,
                userCredentials: {
                    user: action.payload.user,
                    password: action.payload.password
                }
            };

        case SET_MFA_STATUS:
            return {
                ...state,
                mfaStatus: {
                    mfaHabilitado: action.payload.mfaHabilitado,
                    mfaConfirmado: action.payload.mfaConfirmado,
                    codigoDobleAutenticacion: action.payload.codigoDobleAutenticacion,
                }
            };

        case SET_CHAT_CONNECTION_ID:
            return {
                ...state,
                chatConnectionId: action.payload
            };

        default:
            return state
    }
}